export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.admin.invite-user': '邀请用户',
  'menu.admin.cdn-management': 'CDN管理',
  'menu.admin.game-analytics': '游戏数据统计',
  'menu.admin.player-channel-management': '玩家渠道管理',
  'menu.games': '小游戏',
  'menu.statistics': '统计',
  'menu.player-analytics': '玩家分析',
  'menu.game-management': '游戏管理',
  'menu.game-management.review-management': '审核管理',
  'menu.game-management.game-list-management': '游戏管理',
  'menu.game-management.popular-list': '流行榜管理', // 新增流行榜菜单项
  'menu.game-management.new-popular-list': '流行榜管理（新）', // 新增新增流行榜菜单项
  'menu.game-management.channel-management': '渠道管理', // 新增渠道管理菜单项
  'menu.sdk-user': 'SDK 用户管理',
  'menu.projects': '项目列表',
  'menu.project-detail': '项目详情',
  'menu.credentials': '凭证管理',
  'menu.game-selection': '游戏精选',
  'menu.api-docs': 'API文档',
  'menu.api-docs-detail': 'API文档详情',
  'menu.sdk-user.analytics': '数据分析',
  'menu.sdk-user.create': '新建项目',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};